/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import styles from './styles.scss';

const defaultProps = {
  className: '',
  content: '',
  inverse: false,
  theme: 'auto',
  shift: 0,
  enums: null,
  children: null,
};
const propTypes = {
  className: React.PropTypes.string,
  content: React.PropTypes.string,
  inverse: React.PropTypes.bool,
  theme: React.PropTypes.oneOf([
    'auto',
    'blue',
    'red',
    'green',
    'yellow',
  ]),
  shift: React.PropTypes.number,
  enums: React.PropTypes.oneOfType([
    React.PropTypes.array,
    React.PropTypes.func,
  ]),
  children: React.PropTypes.node,
};

class AutoColor extends React.Component {

  colorClass() {
    const {
      content,
      inverse,
      shift,
      enums,
    } = this.props;
    let { theme } = this.props;

    const text = String(content || '');
    if (text === '') {
      return '';
    }

    let index = -1;
    if (enums) {
      if (_.isArray(enums)) {
        const ei = enums.findIndex(e => (e.content === content));
        if (ei >= 0) {
          index = ei;
          theme = enums[ei].theme || theme;
        }
      } else if (_.isFunction(enums)) {
        const e = enums(content);
        index = e.index || index;
        theme = e.theme || theme;
      }
    }
    if (index < 0) {
      index = 0;
      for (let i = 0; i < text.length; i += 1) {
        index += text.charCodeAt(i);
      }
      if (shift) {
        index += shift;
      }
    }

    if (theme === 'auto') {
      theme = ['blue', 'red', 'green', 'yellow'][index % 4];
    }
    if (inverse) {
      return `fg-${theme}-${index % 21}`;
    }
    return `bg-${theme}-${index % 21}`;
  }

  render() {
    const { className } = this.props;
    const color = this.colorClass();
    return (
      <span className={`${styles[color]} ${className}`}>
        {this.props.children}
      </span>
    );
  }
}

AutoColor.defaultProps = defaultProps;
AutoColor.propTypes = propTypes;

export default AutoColor;




// WEBPACK FOOTER //
// ./src/components/AutoColor/index.jsx